function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { spacing64 } from "@churchofjesuschrist/eden-style-constants";
import { dir } from "@churchofjesuschrist/eden-styled-helpers";
const directions = {
  ltr: {
    top: "top",
    bottom: "bottom",
    inlineStart: "left",
    inlineEnd: "right",
    left: "left",
    right: "right",
    topBottom: "topBottom",
    leftRight: "leftRight"
  },
  rtl: {
    top: "top",
    bottom: "bottom",
    inlineStart: "right",
    inlineEnd: "left",
    left: "left",
    right: "right",
    topBottom: "topBottom",
    leftRight: "leftRight"
  }
};
const Container = styled(
/*#__PURE__*/
// eslint-disable-next-line react/display-name
forwardRef((_ref, ref) => {
  let { ...props
  } = _ref;
  delete props.active;
  delete props.to;
  delete props.size;
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, props));
})).withConfig({
  componentId: "sc-1f5lftf-0"
})(["", ";"], _ref2 => {
  let {
    active,
    to,
    size
  } = _ref2;
  return active ? to === "topBottom" ? `mask-image: linear-gradient(to bottom, transparent 0,  rgba(0, 0, 0, 1) ${size}, rgba(0, 0, 0, 1) calc(100% - ${size}), transparent 100%);` : to === "leftRight" ? `mask-image: linear-gradient(to left, transparent 0,  rgba(0, 0, 0, 1) ${size}, rgba(0, 0, 0, 1) calc(100% - ${size}), transparent 100%);` : css(["mask-image:linear-gradient( to ", ",rgba(0,0,0,1) calc(100% - ", "),transparent 100% );", ";"], directions.ltr[to], size, dir("rtl")`
              mask-image: linear-gradient(to ${directions.rtl[to]}, rgba(0, 0, 0, 1.0) calc(100% - ${size}), transparent 100%);
            `) : "";
});
const Fade = /*#__PURE__*/forwardRef((_ref3, ref) => {
  let {
    active = true,
    to = "bottom",
    size = spacing64,
    children,
    ...props
  } = _ref3;
  return /*#__PURE__*/React.createElement(Container, _extends({
    ref: ref,
    active,
    to,
    size
  }, props), children);
});
Fade.displayName = "Fade";
const directionKeys = Object.keys(directions.ltr);
Fade.propTypes = {
  /** The content to fade. */
  children: PropTypes.node,

  /** Boolean flag to indicate if the fade is active */
  active: PropTypes.bool,

  /** The direction to fade towards. */
  to: PropTypes.oneOf(directionKeys),

  /** The size of the fade. Can be any CSS length value but must include the unit. */
  size: PropTypes.string
};
export default Fade;